module.exports = __webpack_public_path__ + "static/media/EduOk.33c109dc.png";